/* eslint-disable dot-notation */
import React, { Component, useState } from "react";
import LoadTimeAccounting from "components/LoadTimer/LoadTimeAccounting.jsx";
import DraggableCard from "components/DraggableCard/DraggableCard.jsx";
import PlantLocation from "./PlantLocations/PlantLocation";
import ProcessFinishedContent from "./ProcessFinishedContent.jsx";

class InstrumentsPanelContent extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => this.setState({ width: window.innerWidth, height: window.innerHeight });

  render() {
    const {
      automationStatus,
      loadingShipment,
      plantLocations,
      refetchConcreteShipmentQuery,
    } = this.props;
    const loadingShipmentId = loadingShipment && loadingShipment.id;

    const zoomEnabled = JSON.parse(localStorage.getItem("zoomEnabled") || "false");

    return (
      <React.Fragment>
        <ProcessFinishedContent
          refetchConcreteShipmentQuery={refetchConcreteShipmentQuery}
          onFinish={this.props.onFinish}
          concreteShipmentId={loadingShipmentId}
        />
        {
          plantLocations.map(location => (
            <PlantLocation
              key={location.id}
              loadingShipment={loadingShipment}
              plantLocation={location}
              width={this.state.width}
              height={this.state.height}
              automationStatus={automationStatus}
              zoomEnabled={zoomEnabled}
            />
          ))
        }
        <DraggableCard
          storageKey="ui.timerCard.position"
          title="CRONÔMETRO"
          defaultPosition={{ x: 120, y: 24 }}
          width={420}
          screenWidth={this.state.width}
          zoomEnabled={zoomEnabled}
        >
          <LoadTimeAccounting
            shipmentId={loadingShipmentId}
            automationStatus={automationStatus}
          />
        </DraggableCard>
      </React.Fragment>
    );
  }
}

export default InstrumentsPanelContent;
